import http from './http.js'

class blkEditApi {
	// 获取文章产品列表
	static getProdAndArtPage(params) {
		return http.httpGet('/edit/prodrel', params)
	}
	// 写入产品文章列表
	static editProdAndArtPage(data) {
		return http.httpPost('/edit/prodreplNew', data)
	}
	// 首页更改产品文章列表
	static editIndexProdAndArt(data) {
		return http.httpPost('/edit/prodrepl', data)
	}
	// 删除当前关联文章或产品
	static removeDelNodes(params) {
		return http.httpGet('/edit/delNodes', params)
	}
	// 获取已经关联的页面，用于数据回显
	static getEchoPage(params) {
		return http.httpGet('/edit/prodrelNew', params)
	}

	// 首页点选修改
	static editIndexProdAndArtPage(data) {
		return http.httpPost('/edit/prodrepl', data)
	}

	// 自定义板块
	static editCustomBlk(data) {
		return http.httpPost('/edit/customBlk', data)
	}
	// 自定义板块 自动读取数据 保存接口
	static customReadBlk(data) {
		return http.httpPost('/edit/customReadBlk', data)
	}

	// 文章列表，产品列表 自定义板块
	static layoutSave(data) {
		return http.httpPost('/layout/save', data)
	}

	static layoutSaveView(params) {
		return http.httpGet('/page/projhtml', params)
	}
	//排序的产品资讯列表数据
	static sortList(params) {
		return http.httpGet('/prodrel/list', params)
	}
	// 产品资讯列表数据的更换排序
	static sortUpdateSort(params) {
		return http.httpPost('/prodrel/updateSort', params)
	}

}
export default blkEditApi
